export const LOGO_URL = "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/4xx51fal_IMG_20260426_134222_560.webp";
export const ARTIST_PORTRAIT = "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/8725xwzq_20250606_195758.jpg";

export const HERO_IMAGES = {
    glitter: "https://images.unsplash.com/photo-1631636507718-f8efdca99602?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    henna: "https://images.unsplash.com/photo-1623217509141-6f735087b50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    face: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/fq2f47zu_20260425_125625.jpg",
    glitterTattoo: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/znzlt2px_20250920_115754.jpg",
    privateHenna: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/q4vpx2oz_20250920_121913.jpg",
};

export const SERVICES = [
    {
        id: "henna",
        kicker: "01",
        name: "Henna",
        tag: "Warm · natural · friendly",
        desc: "Warm, natural henna designs with a friendly approach. Great for kids' parties, festivals, and special celebrations. I focus on beautiful, clean designs rather than highly-detailed bridal work.",
        img: "https://images.unsplash.com/photo-1623217509141-6f735087b50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        accent: "bg-brand-blush",
    },
    {
        id: "face",
        kicker: "02",
        name: "Face Painting",
        tag: "Magical transformations",
        desc: "Vibrant, professional cosmetic paints transformed into butterflies, tigers, superheroes and more. Gentle on sensitive skin and easy to wash off at the end of the day.",
        img: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/f2fjc948_Screenshot_20260507_115032_Chrome.jpg",
        accent: "bg-brand-mint",
    },
    {
        id: "glitter",
        kicker: "03",
        name: "Glitter Tattoos",
        tag: "Sparkle that lasts",
        desc: "Sparkly and water-resistant — perfect for pool parties, summer festivals and weekend birthdays. Lasts 3 to 7 days of shimmering joy.",
        img: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/6wcd86p9_Screenshot_20260507_115053_Chrome.jpg",
        accent: "bg-brand-champagne",
    },
    {
        id: "private",
        kicker: "04",
        name: "Private Henna Sessions",
        tag: "By appointment",
        desc: "For when you just want a beautiful set of hands. Book a one-on-one henna appointment for festivals, weekend treats, or simply for yourself. Non-bridal sessions only.",
        img: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/c27eclji_Screenshot_20250608_130113_Instagram.jpg",
        accent: "bg-brand-blush",
    },
];

export const EVENTS_GRID = [
    { title: "Birthdays & Celebrations", desc: "Birthdays, showers, milestones, cultural moments." },
    { title: "Festivals & Fairs", desc: "High-volume booth setups for crowds." },
    { title: "School & Community", desc: "Carnivals, spirit days, and graduations." },
    { title: "Corporate & Team", desc: "Family days and brand activations." },
];

export const BOOKING_INFO = [
    { icon: "Clock", title: "Hourly Booking", desc: "2-hour minimum for all standard events." },
    { icon: "Gem", title: "Deposit", desc: "$25 non-refundable deposit required to secure your date." },
    { icon: "Sparkles", title: "Setup Needs", desc: "Host provides one table, chair, and adequate lighting." },
    { icon: "Handshake", title: "Combinations", desc: "Services available individually or combined — combination pricing varies slightly." },
    { icon: "Wallet", title: "Payment", desc: "Accepted on the day of your event.", methods: [
        { label: "Venmo", bg: "#008CFF", fg: "#FFFFFF" },
        { label: "Zelle", bg: "#6D1ED4", fg: "#FFFFFF" },
        { label: "Cash",  bg: "#2A8F4D", fg: "#FFFFFF" },
    ] },
];

export const HENNA_PRICING = {
    intro: "Per-design pricing for individual henna appointments. Non-bridal sessions only.",
    tiers: [
        {
            name: "Up to Wrist",
            rows: [
                { label: "1 side · 1 hand design", price: "$20" },
                { label: "Both hands · front side only", price: "$35" },
                { label: "Both hands · back side only", price: "$35" },
                { label: "Both hands · front & back", price: "$65" },
            ],
        },
        {
            name: "Up to Mid-Arm",
            rows: [
                { label: "Both hands · front side only", price: "$80" },
                { label: "Both hands · back side only", price: "$80" },
                { label: "Both hands · front & back", price: "$150" },
            ],
        },
    ],
};

export const VENDOR_INFO = {
    title: "Vendor & Community Partnerships",
    desc: "Have me at your event as a vendor — your guests pay directly for what they get.",
    longDesc: "Vendor partnerships are perfect for festivals, school carnivals, community fairs and brand activations. I bring the full booth, design book and supplies — your guests pay per design at the booth. It's a win-win: zero cost to your attendees' experience, and a lively, photo-worthy activity that draws people in.",
    items: [
        "$50 flat booking fee",
        "Free for verified non-profit organizations",
        "I bring the full booth, supplies, and design book",
        "Per-design pricing for guests at the booth",
        "Ideal for festivals, schools, community fairs",
    ],
};

export const AVAILABILITY = [
    { day: "Friday", hours: "5:30 PM – 2:00 AM" },
    { day: "Saturday", hours: "8:00 AM – 2:00 AM" },
    { day: "Sunday", hours: "8:00 AM – 9:00 PM" },
    { day: "Other times", hours: "Just ask — happy to flex for the right event." },
];

// 2026 + 2027 US federal holidays (no time restriction on the inquiry form for these dates)
export const US_HOLIDAYS = [
    "2026-01-01", "2026-01-19", "2026-02-16", "2026-05-25", "2026-06-19",
    "2026-07-03", "2026-07-04", "2026-09-07", "2026-10-12", "2026-11-11",
    "2026-11-26", "2026-12-25",
    "2027-01-01", "2027-01-18", "2027-02-15", "2027-05-31", "2027-06-18",
    "2027-06-19", "2027-07-04", "2027-07-05", "2027-09-06", "2027-10-11",
    "2027-11-11", "2027-11-25", "2027-12-24", "2027-12-25",
];

export const TRAVEL_INFO = "Free within Pittsburg, CA. Outside Pittsburg, a flat $0.70 per mile (round trip) from ZIP 94565.";

export const GALLERY = [
    // Henna — all real work
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/c27eclji_Screenshot_20250608_130113_Instagram.jpg", category: "henna", alt: "Two-hand floral henna at event" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/h9n4ug3a_20250612_192657.jpg", category: "henna", alt: "Detailed scalp henna mandala — bold statement piece" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/dak8k2mt_20250607_012906.jpg", category: "henna", alt: "Flowing finger henna across all fingers" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/obo00ute_20250607_005905.jpg", category: "henna", alt: "Floral mandala henna with vine to fingertip" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/406hb476_20250606_205942.jpg", category: "henna", alt: "Elaborate finger henna with floral cuff" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/q4vpx2oz_20250920_121913.jpg", category: "henna", alt: "Floral henna with vine on hand" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/zibrg3tk_20250606_195757.jpg", category: "henna", alt: "Detailed mandala henna" },
    // Face painting (originals + new uploads)
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/zs836aid_20260425_151317.jpg", category: "face", alt: "Rainbow swirl face paint" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/kur6zafs_20260425_145746.jpg", category: "face", alt: "Pink butterfly face paint, tongue-out smile" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/tbvxgra4_20260425_150412.jpg", category: "face", alt: "Pink flower tiara face paint" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/7lkiede4_20260425_143506.jpg", category: "face", alt: "Pink flower face paint" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/v0s620zw_20260425_135321.jpg", category: "face", alt: "Spider-Man red face paint" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/f2fjc948_Screenshot_20260507_115032_Chrome.jpg", category: "face", alt: "Bold red Spider-Man face paint" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/fq2f47zu_20260425_125625.jpg", category: "face", alt: "White floral face paint" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/89a0424x_20260425_134719.jpg", category: "face", alt: "Red superhero mask" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/ipjwt8q1_20260425_133145.jpg", category: "face", alt: "Green leaf face paint" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/ozitmmxh_20260425_135324.jpg", category: "face", alt: "Spider-Man on man" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/oudmz2bu_20260425_131916.jpg", category: "face", alt: "Pink butterfly side-eye" },
    // Glitter tattoos
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/6wcd86p9_Screenshot_20260507_115053_Chrome.jpg", category: "glitter", alt: "Sparkling blue and pink glitter butterfly with shimmer dust" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/h8zxkigj_Screenshot_20260507_174319_Chrome.jpg", category: "glitter", alt: "Red Spider-Man glitter tattoo on arm" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/xckbnntw_Screenshot_20260507_174432_Chrome.jpg", category: "glitter", alt: "Pink and purple glitter star stencils on wrist" },
    { src: "https://customer-assets.emergentagent.com/job_glow-momentz-hub/artifacts/om25jcqt_Screenshot_20260507_174602_Chrome.jpg", category: "glitter", alt: "Pink and purple glitter heart on wrist" },
];

export const TESTIMONIALS = [
    { name: "Priya R.", event: "Diwali Fundraiser · Pittsburg", quote: "Glow Momentz turned a simple fundraiser into something magical. Guests are still texting me about the henna line — it never stopped buzzing." },
    { name: "Marcus & Lina", event: "Anniversary Party · Concord", quote: "The henna designs were beautiful and so warm — guests of every age lined up. Lasted weeks and photographed gorgeously." },
    { name: "Jessie T.", event: "5th Birthday · Antioch", quote: "My daughter still talks about her butterfly face six months later. Patient, gentle, and the kids were mesmerized. Worth every penny." },
    { name: "Aanya S.", event: "Tech Team Offsite · Walnut Creek", quote: "We booked the glitter station as a surprise icebreaker. Engineers walking around in glitter tattoos — it instantly broke the ice. 10/10." },
];

export const FAQS = [
    { q: "How far in advance should I book?", a: "I recommend 4–6 weeks for weekends and peak seasons (May–October). For smaller weekday events I can sometimes accommodate 1–2 weeks notice — just ask." },
    { q: "Do you travel beyond Pittsburg, CA?", a: "Yes! Travel is free within Pittsburg, CA. Outside Pittsburg, it's a flat $0.70 per mile (round trip) from ZIP 94565." },
    { q: "How do I pay?", a: "I accept Venmo, Zelle, and cash. The $25 non-refundable deposit secures your date; the remaining balance is due the day of the event." },
    { q: "Is your henna safe? What about face paint?", a: "Always. I use 100% natural, body-safe henna (no PPD or chemical 'black henna' — ever). My face and glitter paints are FDA-compliant, hypoallergenic and skin-safe for all ages." },
    { q: "How long does henna / glitter last?", a: "Henna: 1–2 weeks depending on placement and aftercare. Glitter tattoos: 3–7 days, water-resistant. Face paint: same-day, washes off easily with soap and water." },
    { q: "Do you do bridal henna?", a: "I do not offer bridal henna. I focus on beautiful, clean designs for parties, festivals and private sessions — non-bridal only." },
    { q: "Can I combine services?", a: "Yes! Mix any of my three services for your event. Combination pricing varies a bit — I'll quote you a custom rate based on your guest count and hours." },
    { q: "What does the host need to provide?", a: "Just a table, a chair, and adequate lighting. I bring everything else — supplies, design book, and the energy." },
];
